import type {
    ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions_BasicActivitySession as BasicActivitySession,
    ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions_MasteryActivitySession as MasteryActivitySession,
} from "./__graphql-types__/ActivitySessionsV2Query.ts";

function isBasicActivitySession(
    row: BasicActivitySession | MasteryActivitySession,
): row is BasicActivitySession {
    return row.__typename === "BasicActivitySession";
}

export default isBasicActivitySession;
